var $1f98a9a2c7c0a09d$exports = {};
$1f98a9a2c7c0a09d$exports = {
    "alert": `\u{8B66}\u{62A5}`,
    "dismiss": `\u{53D6}\u{6D88}`
};


export {$1f98a9a2c7c0a09d$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
